import styled from 'styled-components';
import {
  Button as DefaultButton,
  ScreenWarning as DefaultScreenWarning,
  Plus as DefaultPlus,
} from '~components';

export const ScreenWarning = styled(DefaultScreenWarning)`
  margin-bottom: ${({ theme }) => theme.spacing.km12};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km8};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.km12};
  height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km8};
  }
`;

const Plus = styled(DefaultPlus)`
  margin-left: ${({ theme }) => theme.spacing.km2};
`;

export const ButtonWithPlus = styled(DefaultButton).attrs({
  icon: <Plus />,
  width: 'fit-content',
  variant: 'secondary',
})`
  flex-shrink: 0;
  margin-top: ${({ theme }) => theme.spacing.km12};
  margin-bottom: ${({ theme }) => theme.spacing.km12};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    margin-top: ${({ theme }) => theme.spacing.km6};
    margin-bottom: ${({ theme }) => theme.spacing.km8};
  }
`;
